const STORE_PREFIX = 'indieye:phase2:snapshot:';

const memoryStore = new Map<string, string>();

function toStorageKey(key: string): string {
    return `${STORE_PREFIX}${key}`;
}

function safeSetStorage(key: string, value: string): void {
    try {
        sessionStorage.setItem(toStorageKey(key), value);
    } catch {
        // Ignore storage failures and keep in-memory snapshot.
    }
}

function safeGetStorage(key: string): string | null {
    try {
        return sessionStorage.getItem(toStorageKey(key));
    } catch {
        return null;
    }
}

export function setSnapshot<T>(key: string, payload: T): void {
    const serialized = JSON.stringify(payload);
    memoryStore.set(key, serialized);
    safeSetStorage(key, serialized);
}

export function getSnapshot<T>(key: string): T | null {
    const fromMemory = memoryStore.get(key);
    if (fromMemory) {
        try {
            return JSON.parse(fromMemory) as T;
        } catch {
            return null;
        }
    }

    const fromStorage = safeGetStorage(key);
    if (!fromStorage) return null;

    memoryStore.set(key, fromStorage);
    try {
        return JSON.parse(fromStorage) as T;
    } catch {
        return null;
    }
}

export function clearSnapshot(key: string): void {
    memoryStore.delete(key);
    try {
        sessionStorage.removeItem(toStorageKey(key));
    } catch {
        // Ignore storage failures.
    }
}
